<template>
<div>
		<div class="row">
			<div class="col-sm-12 ">
				<div class="module_title"> <span class="focus_color">请设置报警指标</span> </div>
			</div>
		</div>
		<div class="row grey_box ofh mb10px">
					<form class="form-horizontal grey_box col-sm-12">
						<div class="form-group pt5px">
						    <span style="padding-left:9px;">车辆出现以下任意一种故障码时，将触发报警：<a style="padding-left:20px;" class="text-center">点此查看故障码说明</a></span>
						</div> 
						<div class="form-group">
							<label class="col-sm-1 control-label">故障码</label>
							<div class="col-sm-3">
								<!--<select class="form-control" v-model="selectError" >
									<option v-for="obd in obdErrCode" v-bind:value="obd">
										{{obd.obdErrorCode}}[{{obd.content}}]
									</option>
									
								</select>	-->
								
								<multiselect v-model="selectError" :options="obdErrCode" label="content" placeholder="请输入故障码">
								</multiselect>
							</div>
							<label class="col-sm-1 control-label">故障说明</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" v-model="selectError.content2" readonly="true" :title="selectError.content2">
							</div>
							<div class="col-sm-1 text-right">
							    <div class="form-group">
                        		    <button type="button" v-if="permission.indexOf('alarmTarget_thresholdAdd') == -1" :disabled="selectError==''" class="btn btn-primary" @click="addErrorCode">添加阈值</button>
                        	    </div>
						    </div>
						</div>
						<div class="hr-line-dashed"></div>
						<div class="form-group">
				   			<div class="col-sm-1 text-left">
								<button type="button" v-if="permission.indexOf('alarmTarget_thresholdAddAll') == -1" class="btn btn-primary" @click="addAllErrorCode">添加全部</button>
							</div>
							<div class="col-sm-1 text-left">
								<button type="button" v-if="permission.indexOf('alarmTarget_thresholdDeleteAll') == -1" class="btn btn-primary" @click="clearThresholdErrorCode">全部删除</button>
							</div>
						</div>
						
						<div class="col-sm-7" style="padding-left:20px;">
							<table class="table  table-striped table-bordered">
								<thead>
									<tr>
										<th></th>
										<th class="text-center">故障码</th>
										<th class="text-center">故障说明</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item,index) in ResultInfo.data" v-bind:key="index">
										<td class="text-center">
											<a class="text-center" v-if="permission.indexOf('alarmTarget_thresholdDelete') == -1" @click="deleteThreshold(item)"><i class="glyphicon glyphicon-trash"></i></a>
										</td>
										<td>{{item.obdErrorCode}}</td>
										<td>{{item.content}}</td>
									</tr>
								</tbody>
							</table>
						<!--分页组件开始-->
							<pagination v-if='ResultInfo.data.length>0' :pageInfo="ResultInfo.PageInfo" v-on:getData="getResultPageNo"></pagination>
						<!--分页组件结束-->
						</div>
				   </form>
			   </div>
</div>
	
	
</template>

<script>
import Pagination from 'components/common/Pagination'
import { OPERATE_EXCEPTION} from 'static/message'
import Multiselect from 'vue-multiselect'
import 'assets/plugins/multiselect/vue-multiselect.min.css'

export default{
	name: 'AlarmErrorNum',
	components: {
    	Pagination,
    	Multiselect
   	},
	data(){
		return{
			permission:this.$store.state.permission.permission[this.parentid]?this.$store.state.permission.permission[this.parentid]:[],
			typeid:"15",						  //当前报警计划类型
			selectError:'',
			obdErrCode:[],       //下拉列表
			ResultInfo:{
				PageInfo:{},
				data:[]
			},
			queryParam:{
				isAllSel:0,
				opTargetId:15,
				operationType:0,
				thresholdType:'obdErrorCode',
				page_index: 1,	
			}
			
		}
	},
	props:{
		mode:{
			default:0
		},
		planid:{
			default:0
		}
		
	},
	watch:{
		'selectError'(){
		}
	},
	beforeMount(){
		this.getSelectData();
		if(this.mode==0)
		this.clearThresholdErrorCode();
		if(this.mode==1 || this.mode==2)
		this.beginEdit();
	},
	methods:{
		//获取缓存 	编辑模式下	用一个接口
		getThreshold(){
			let param;
			if(this.mode==0){
				this.queryParam.operationType=0;
				this.queryParam.opTargetId =15
			}
			if(this.mode==1 || this.mode==2){
				this.queryParam.operationType=1;
				this.queryParam.opTargetId =this.planid; 
			}
			
			this.$http.get(process.env.API_ROOT + "/alarm/alarm-plans/obderror-codes",{params:this.queryParam})
			.then((res)=>{
				this.ResultInfo.data = res.data.data.list;
				const {pageNum,pages,total,isFirstPage,isLastPage} = res.data.data;
				this.ResultInfo.PageInfo = {								
								pageNum:pageNum,
								pages:pages,		
								total: total,
								isFirstPage:isFirstPage,
								isLastPage:isLastPage
				};
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			});
			
		},
		//添加故障码到缓存
		addErrorCode(){
			if(this.selectError=='')return ;
			let param ={};
			if(this.mode==1 || this.mode==2){
				param.isAllSel =0;
				param.opTargetId = this.planid;
				param.operationType =1;
				param.thresholdList =[this.selectError.obdErrorCode],
				param.thresholdType ='obdErrorCode'
			}
			if(this.mode==0){
				param.isAllSel =0;
				param.opTargetId = 15;
				param.operationType =0;
				param.thresholdList =[this.selectError.obdErrorCode],
				param.thresholdType ='obdErrorCode'
			}	
			this.$http.post(process.env.API_ROOT + "/alarm/alarm-plans/temp/threshold",param)
			.then((res)=>{
				if(res.data.success)
				this.getThreshold()		
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			})
				
		},
		//添加全部
		addAllErrorCode(){
			let param ={};
			param.isAllSel =1;
			param.opTargetId = 15;
			param.operationType = 0;
			param.thresholdType ='obdErrorCode',
			this.$http.post(process.env.API_ROOT + "/alarm/alarm-plans/temp/threshold",param)
			.then((res)=>{
				if(res.data.success)
				this.getThreshold()		
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			})
		},
		//获取下拉框数据
		getSelectData(){
			this.$http.get(process.env.API_ROOT + "/alarm/alarm-plans/obderror-codes-select")
			.then((res)=>{
				this.obdErrCode =res.data.data;
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			});
			
		},
		//清空缓存
		clearThresholdErrorCode(){
			let param;
			
			if(this.mode==0){
				param ={
				opTargetId:15,
				operationType:0,
				thresholdType:'obdErrorCode'	
				};
			}
			if(this.mode==1 || this.mode==2){
				param ={
				opTargetId:this.planid,
				operationType:1,
				thresholdType:'obdErrorCode'	
				}
			}
				
			this.$http.delete(process.env.API_ROOT + "/alarm/alarm-plans/clear-temp/threshold", {body:param})
			.then((res)=>{
				if(res.data.success){
					this.ResultInfo.data=[];
					this.getThreshold();
				}else{
					this.$parent.openModalMsg(res.data.message);
				}
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			});
	
		},
		//移除一个故障码
		deleteThreshold(item){
			let param ={};
			param.isAllSel =0;
			param.opTargetId = 15;
			param.operationType =0;
			param.thresholdList =[item.obdErrorCode];
			param.thresholdType ='obdErrorCode';
			param.thresholdValue =item.obdErrorCode;
			this.$http.delete(process.env.API_ROOT + "/alarm/alarm-plans/temp/threshold",{body:param})
			.then((res)=>{
				if(res.data.success)
				this.getThreshold()		
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			})
			
		},
		//监控列表分页
		getResultPageNo(pageNo) { 
			this.ResultInfo.pageNo = pageNo;
			this.queryParam.page_index = pageNo;
			this.getThreshold();
		},
		//开始编辑 获取基本信息
		beginEdit(){		
			this.$http.get(process.env.API_ROOT + "/alarm/alarm-plans/"+this.planid+"/threshold?almType=15")
			.then((res)=>{
				this.getThreshold();
			}, (res) => {
				this.$parent.openModalMsg(res.data.message);
			})
			.catch((res) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
			});
		}
		
		
	}
}
	
</script>

<style>
</style>


// WEBPACK FOOTER //
// AlarmErrorNum.vue?4ea0887a